module.exports = __webpack_public_path__ + "static/media/om_eyeshape_almond_blue.454eae2d.png";